import React, { useState, useContext, useRef } from "react";
import { addDiscount, removeDiscount } from "data/cart";
import * as styles from "./style.mod.scss";
import useToggle from "helpers/toggle-state";
import GlobalContext from "services/global-context";
import translations from "locales";
import Money from "components/money";

const DiscountCode = ({ showDiscountField, discountCode, errorMessage, freeProducts }) => {
  const { cart, refreshCart, cartSettings } = useContext(GlobalContext);
  const [discount, setDiscount] = useState(discountCode ?? "");
  const [discountKeyTimeout, setDiscountKeyTimeout] = useState(null);
  const [showDiscount, toggleDiscount] = useToggle(false);
  const [validDiscount, setValidDiscount] = useState();
  const [discountLoading, setDiscountLoading] = useState();
  const cartLoc = translations?.cart;
  let _discountRef = useRef(null);
  const totalDiscounts = cart?.totalSavings + cart?.discountedAmount;


  const clearDiscount = async () => {
    setDiscountLoading(true);
    const prevDiscount = cart?.discount?.code;
    setDiscount(null);
    await removeDiscount();
    if (prevDiscount !== null) await refreshCart();
    setDiscountLoading(false);
    toggleDiscount();
  };

  const attachDiscount = (withTimeout = true) => {
    const discountCode = _discountRef.value;
    if (discountCode === "") {
      clearDiscount();
      setValidDiscount("");
      return;
    }

    setDiscount(discountCode);
    clearTimeout(discountKeyTimeout);
    const timeout = setTimeout(async () => {
      setDiscountLoading(true);
      const updatedCart = await addDiscount(discountCode, cartSettings.freeProd);
      if (updatedCart.discountApplications.length !== 0) {
        setValidDiscount("");
        await refreshCart();
        toggleDiscount();
      } else {
        setValidDiscount(updatedCart?.userErrors[0]?.message.replace("Discount code", ""));
      }
      setDiscountLoading(false);
    }, withTimeout ? 750 : 0);
    setDiscountKeyTimeout(timeout);
  };


  return (
    <div>
      {(showDiscountField && showDiscount) ?
        <div className={styles.discountWrapper}>
          <input
            type="text"
            className={styles.discountInput}
            placeholder=" "
            ref={(_ref) => _discountRef = _ref}
            autoFocus={true}
            onKeyDown={(e) => e.key === "Enter" && attachDiscount(false)}
          />
          <span>{cartLoc.discountCode}</span>
          <button
            className={styles.discountBtn}
            onClick={() => attachDiscount(false)}
          >
            {discountLoading ? <div className={styles.discountLoader} /> : cartLoc.apply}
          </button>
        </div>
        :
        showDiscountField && <a className={styles.discount} onClick={toggleDiscount}>
          {cart.hasDiscounts ?
            <div className={styles.discountInfos} onClick={() => clearDiscount()}>
              <div className={styles.discountContainer}>
                <span>{cartLoc.discountCode}</span>
                <div className={styles.savedAmount}>
                  {totalDiscounts > 0 &&
                    <>
                      {cart?.discount?.perc > 0 ? <span>-{cart?.discount?.perc}% </span> : <Money value={-cart?.discountedAmount} currency={cart?.totalPriceV2?.currencyCode} />}
                      <span> {cartLoc.appliedDiscount} </span>

                    </>}
                </div>
              </div>
              <span className={styles.discountTotal}>
                <div className={styles.discountBox}>
                  <span>{cart?.discountName === undefined ? cart?.discount?.code : cart?.discountName}</span> <div className={styles.removeDiscountX}>X</div>
                </div>
              </span>
            </div>
            :
            <span>{cartLoc.discountCode} +</span>}
        </a>
      }
      {discount?.match(freeProducts?.discountMatch) && <span className={styles.errorDiscount}>{errorMessage}</span>}
      {validDiscount && <span className={styles.errorDiscount}>{validDiscount} </span>}
    </div>
  );
};

export default DiscountCode;